import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=26955595&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"
import style0 from "./Friends.vue?vue&type=style&index=0&id=26955595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26955595",
  null
  
)

export default component.exports